<template>
    <div class="flex-column">
        <div class="flex-column items-center mt30">
            <div class="fs16 bold">{{companyName}}</div>
        </div>
        <div class="pd30">
            <div>
                <div class="fs14">请输入手机号</div>
                <div class="mt5">
                    <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                </div>
            </div>
            <div class="mt15">
                <div class="fs14">请输入姓名</div>
                <div class="mt5">
                    <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                </div>
            </div>
            <div class="mt15">
                <div class="fs14">请输入密码</div>
                <div class="mt5">
                    <el-input v-model="form.password" placeholder="请输入密码"></el-input>
                </div>
            </div>
            <div class="mt15">
                <div class="fs14">请选择职位</div>
                <div class="mt5">
                    <el-select v-model="form.role" placeholder="请选择职位" class="w100">
                        <el-option
                            v-for="item in groups"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="mt30">
                <el-button class="w100" type="success" @click="submit">加入</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyName: "",
            form: {
                phone: "",
                name: "",
                role: null,
            },
            groups: []
        }
    },
    created() {
        this.token = this.$route.params.token;
        this.form.token = this.token;
        this.getCompanyByToken();
        this.getGroupsByToken();
    },
    methods: {
        async getCompanyByToken() {
            let rs = await this.$api.getCompanyByToken(this.token);
            if (rs.err == 0) {
                this.companyName = rs.data;
            }
        },
        async getGroupsByToken() {
            let rs = await this.$api.getGroupsByToken(this.token);
            if (rs.err == 0) {
                this.groups = rs.data;
            }
        },
        async submit() {
            if (this.form.phone != "" && this.form.role != null) {
                let rs = await this.$api.createUserByToken(this.form);
                if (rs.err == 0) {
                    this.$message({
                        message: '创建成功',
                        type: 'success'
                    });
                } else if (rs.err == 2) {
                    this.$message("该手机号已被注册");
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>

</style>